import type { KambiValidReward } from '@mobi/api-types/kambi/player/reward'
import { toTitleCase } from '@mobi/utils/string'

export function getKambiRewardTitle(reward: KambiValidReward): string {
  let title = ''

  const metaTagName = reward.metadata?.tags.find(tag => tag.key === 'rewardName')?.value || ''
  if (metaTagName) {
    title += metaTagName
  }

  if (reward.profitBoostProperties) {
    const rewardPercentage = reward.profitBoostProperties.boostPercentage
    title += ` ${rewardPercentage}%`
  }

  title += ` ${toTitleCase(reward.rewardType.split('_').join(' '))}`

  return title
}
